import { render, staticRenderFns } from "./CardConsult.vue?vue&type=template&id=47b0552e"
import script from "./CardConsult.vue?vue&type=script&lang=js"
export * from "./CardConsult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports